import { atom } from 'jotai';

import { defaultSchemaValues, type SettingsSchemaType } from '../model/SettingsSchema';

export const settingsAtom = atom<SettingsSchemaType, [SettingsSchemaType], void>(
	defaultSchemaValues,
	(_, set, newSettings) => {
		set(settingsAtom, newSettings);
		set(areSettingsLoadedAtom, true);
	}
);

export const areSettingsLoadedAtom = atom<boolean>(false);
